import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ShoppingCategoryPage from "./shopping-category-page";
import ShoppingCategoryCreatePage from "./shopping-category-create-page";
import ShoppingCategoryEditPage from "./shopping-category-edit-page";

export default (
  <Route path="shopping-category">
    <Route
      index
      element={
        <Protected
          path="/admin/shopping-category"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCategoryPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/shopping-category/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCategoryCreatePage />
        </Protected>
      }
    />

    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/shopping-category/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCategoryEditPage />
        </Protected>
      }
    />
  </Route>
);
